import React, { useState, useEffect } from "react";
import api from "../../utils/axiosConfig";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "./CartContext";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const colorMap = {
  blanc: "#ffffff", noir: "#000000", rouge: "#ff0000",
  bleu: "#0000ff", vert: "#008000", jaune: "#ffff00",
  gris: "#808080", orange: "#ffa500", violet: "#800080",
  rose: "#ff69b4", marron: "#a52a2a",
};
export default function AddToCart({ product, selectedColor, selectedTaille, setSelectedColor, setSelectedTaille }) {
  const { refreshCartCount } = useCart() || {};
  const navigate = useNavigate();
  const location = useLocation();

  const [quantity, setQuantity] = useState(1);
  const [checkingAuth, setCheckingAuth] = useState(false);

  // Pour vérifier si la couleur/ taille sélectionnée est en stock (depuis product)
  const fullStock = product.variantes.flatMap(v =>
    v.stock.map(s => ({
      ...s,
      couleur: v.couleur,
      images: v.images || [],
    }))
  );

  const selectedStock = fullStock.find(
    s => s.couleur === selectedColor && s.taille === selectedTaille
  );

  const handleQuantityChange = (delta) => {
    const newQty = quantity + delta;
    if (newQty < 1) {
      setQuantity(1);
      toast.info("Quantité minimale : 1");
      return;
    }
    if (selectedStock && newQty > selectedStock.quantity) {
      setQuantity(selectedStock.quantity);
      toast.warning(`Il ne nous reste que ${selectedStock.quantity} exemplaire${selectedStock.quantity > 1 ? 's' : ''} de ce modèle en taille ${selectedTaille} et couleur ${selectedColor}`);
      return;
    }
    setQuantity(newQty);
  };

  const checkAuth = async () => {
    try {
              await api.get(`/api/auth/check`);
      return true;
    } catch {
      return false;
    }
  };

  const handleAdd = async () => {
    if (!selectedColor || !selectedTaille) {
      toast.error("Veuillez sélectionner une couleur et une taille.");
      return;
    }
    if (!selectedStock) {
      toast.error("Cette combinaison couleur/taille n'est pas disponible.");
      return;
    }
    if (selectedStock.quantity === 0) {
      toast.error("Ce produit est en rupture de stock pour cette combinaison.");
      return;
    }
    if (selectedStock.quantity < quantity) {
      toast.error(`Stock insuffisant. Disponible : ${selectedStock.quantity}, demandé : ${quantity}`);
      return;
    }

    setCheckingAuth(true);
    const isAuth = await checkAuth();
    setCheckingAuth(false);
    if (!isAuth) return navigate("/login", { state: { from: location.pathname } });

    try {
              await api.post(`/api/shop/cart/add`, {
        productId: product._id,
        couleur: selectedColor,
        taille: selectedTaille,
        quantity,
      }, { withCredentials: true });

      toast.success("Ajouté au panier !", {
        onClick: () => navigate('/cart'),
        style: { cursor: 'pointer' }
      });
      refreshCartCount?.();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de l'ajout.");
    }
  };

  return (
    <div style={{ marginTop: "1.5rem" }}>
      {/* Quantité */}
      <div style={{ marginTop: "1rem" }}>
        <div style={{ fontWeight: "bold", marginBottom: "6px" }}>QUANTITÉ :</div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <motion.button onClick={() => handleQuantityChange(-1)} whileTap={{ scale: 0.95 }} style={qtyBtnStyle}>−</motion.button>
          <span style={{ fontWeight: "600", minWidth: "24px", textAlign: "center" }}>{quantity}</span>
          <motion.button onClick={() => handleQuantityChange(1)} whileTap={{ scale: 0.95 }} style={qtyBtnStyle}>+</motion.button>
        </div>
      </div>

      {/* Ajouter au panier */}
      <motion.button
        onClick={handleAdd}
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.98 }}
        disabled={checkingAuth}
        style={{
          marginTop: "16px",
          width: "100%",
          padding: "16px 0",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          color: "#2c1810",
          fontWeight: "600",
          fontSize: "1.2rem",
          border: "none",
          borderRadius: "15px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: "0.5px",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        }}
        onMouseEnter={(e) => {
          if (!checkingAuth) {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 8px 25px rgba(74, 222, 128, 0.3)";
            e.target.style.borderColor = "#22c55e";
          }
        }}
        onMouseLeave={(e) => {
          if (!checkingAuth) {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.1)";
            e.target.style.borderColor = "#4ade80";
          }
        }}
      >
        {checkingAuth ? "Connexion..." : "AJOUTER AU PANIER"}
      </motion.button>
    </div>
  );
}

const qtyBtnStyle = {
  padding: "6px 12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  background: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
};
